module.exports = __webpack_public_path__ + "img/BPSYS.5bbcd598.jpg";